import React from 'react';

import { useFormContext } from 'react-hook-form';
import { Button } from '@infoods/lifebase-ui';

import { CustomFilterFormValues } from '../../AddCustomFilterForm.settings';
import { useClearFilter } from '../../hooks/useClearFilter';
import { ModalInputBox, ModalInputGroup } from '../../../../../../../components/modals';
import {
  HiddenInput,
  SelectSportPickers,
} from '../../../../../../../components/form-components';
import { useSports } from './hooks/useSports';

const SportFilters = () => {
  const { control, register } = useFormContext<CustomFilterFormValues>();

  const { sports } = useSports();

  const { disabled, handleClearFields } = useClearFilter('SCHOOL', {
    position: '',
    sport: null,
  });

  return (
    <ModalInputBox
      title="Sport"
      adornment={
        <Button
          size="small"
          variant="text"
          color="secondary"
          onClick={handleClearFields}
          disabled={disabled}
        >
          Clear
        </Button>
      }
    >
      <HiddenInput register={register} name="filters.SCHOOL.filterType" value="SCHOOL" />
      <ModalInputGroup>
        <SelectSportPickers
          control={control}
          sports={sports}
          variant="outlined"
          sportFieldProps={{
            name: 'filters.SCHOOL.sport',
          }}
          sportPositionFieldProps={{
            name: 'filters.SCHOOL.position',
          }}
        />
      </ModalInputGroup>
    </ModalInputBox>
  );
};

export { SportFilters };
